import React from 'react';
import './button.css';

export const BUTTON_TYPES = {
  CTA: 'cta-button',
  CANCEL: 'cancel-button',
  PRIMARY: 'primary-button',
  PILLS: 'pills-button',
  DELETE: 'delete-button',
  ICON: 'icon-button'
};

export const BUTTON_SIZES = {
  SMALL: 'small-button',
  REGULAR: ''
}

export default function Button(props) {
  const {type, size, label, onClick, style = {}, disabled, onDoubleClick, icon, altText, block} = props;

  const className = `${type || BUTTON_TYPES.PRIMARY} ${size || BUTTON_SIZES.REGULAR}`;
  const buttonStyle = block ? {display: 'block', marginBottom: 5, ...style} : style;

  return (
    <button className={className} onClick={onClick} style={buttonStyle} disabled={disabled} onDoubleClick={onDoubleClick}>
      {type === BUTTON_TYPES.ICON ? <img src={icon} alt={altText} /> : label}
    </button>
  );
}
